<template>
  <div
    class="headerCartBox set-item"
    @mouseover="openCart"
    @mouseleave="closeCart"
  >
    <div class="headerCartBtn">
      <div class="headerCart" @click="cartHref">
        <div class="set-icon">
          <img :src="carIcon" title="購物車" alt="" />
        </div>
        <span id="cartCount" class="count" v-text="totalCount"></span>
        <span
          id="courseCartCount"
          class="count"
          v-text="totalCourseCount"
        ></span>
      </div>
    </div>
    <div
      v-show="showCart"
      id="preCart"
      class="preCart"
      @mouseleave="closeCart"
    >
      <div id="preCartInnerBox" class="preCartInnerBox">
        <div id="preCartProduct" class="preCartProduct">
          <div class="preCartTitle">
            <div class="preCartIcon productIcon">
              <img src="img/pic/cart.svg" alt="" />
            </div>
            產品購物車
          </div>
          <template v-if="Carts">
            <template v-for="(Cart, key) in Carts">
              <div
                v-if="Cart.Product"
                :key="Cart.id"
                class="preCartContent"
              >
                <div class="preCartPic">
                  <img :src="Cart.Product.picUrl" @error="handleImageError" alt="" />
                </div>
                <div class="preCartText">
                  <div class="preCartNameBox">
                    <div class="preCartName">
                      <a :href="`product/${Cart.Product.slug}`">
                        {{ Cart.Product.name }}
                      </a>
                    </div>
                    <div
                      class="deleteBtn"
                      @click="deleteProductItem(Cart.id, key)"
                    >
                      <img src="img/pic/cart-delect.png" alt="" />
                    </div>
                  </div>
                  <div class="preCartSpec" v-text="Cart.text"></div>
                  <div class="preCartAmount">
                    數量：{{ Cart.amount }}
                  </div>
                </div>
              </div>
            </template>
          </template>
          <template v-else>
            <div class="preCartEmpty">購物車目前是空的</div>
          </template>
        </div>
        <div class="preCartCourse">
          <div class="preCartTitle">
            <div class="preCartIcon">
              <img src="img/pic/courseCart.svg" alt="" />
            </div>
            課程購物車
          </div>
          <template v-if="CourseCarts">
            <template v-for="(CourseCart, key) in CourseCarts">
              <div
                v-if="CourseCart.Course"
                :key="CourseCart.id"
                class="preCartContent"
              >
                <div class="preCartPic">
                  <img :src="CourseCart.Course.picUrl" @error="handleImageError" alt="" />
                </div>
                <div class="preCartText">
                  <div class="preCartNameBox">
                    <div class="preCartName">
                      <a :href="`course/${CourseCart.Course.slug}`">
                        {{ CourseCart.Course.name }}
                      </a>
                    </div>
                    <div
                      class="deleteBtn"
                      @click="deleteCourseItem(CourseCart.id, key)"
                    >
                      <img src="img/pic/cart-delect.png" alt="" />
                    </div>
                  </div>

                  <div
                    class="preCartSpec"
                    v-text="CourseCart.text"
                  ></div>
                  <div class="preCartAmount">
                    數量：{{ CourseCart.amount }}
                  </div>
                </div>
              </div>
            </template>
          </template>
          <template v-else>
            <div class="preCartEmpty">購物車目前是空的</div>
          </template>
        </div>
        <!-- <div v-show="sticky" class="preCartStickyTitle">
          <div class="preCartIcon">
            <img src="img/pic/courseCart.svg" alt="" />
          </div>
          課程購物車
        </div> -->
      </div>
      <div class="preCartBtnBox">
        <a href="cart" class="preCartBtn">
          <div class="preCartIcon productIcon">
            <img src="img/pic/cartWhite.svg" alt="" alt="" />
          </div>
          前往產品購物車
        </a>
        <div class="divider"></div>
        <a href="coursecart" class="preCartBtn">
          <div class="preCartIcon">
            <img src="img/pic/courseCartWhite.svg" alt="" />
          </div>
          前往課程購物車
        </a>
      </div>
      <div id="loadOrder" @click="loadOrder"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'pageType',
  ],
  data() {
    return {
      Carts: [],
      CourseCarts: [],
      Order: Json.Order,
      CourseOrder: Json.CourseOrder,
      totalCount: 0,
      totalCourseCount: 0,
      showCart: false,
      sticky: false,
      isLoad: false,
      carIcon: 'img/pic/cart.svg'
    };
  },
  created() {},
  beforeMount() {
    /* 過濾 tightbundle children*/
    this.CourseCarts = this.filterCart(Json.CourseOrder.Carts);
    this.Carts = this.filterCart(Json.Order.Carts);
    if (this.pageType == 'frontend'){
      this.carIcon = 'img/pic/cartWhite.svg';
    }
  },
  mounted() {
    this.calcTotalCount();
  },
  methods: {
    filterCart(data){
      if(data){
        return data.filter(cart => cart.parentId == 0 || cart.parentId == null);
      }else{
        return [];
      }
    },
    calcTotalCount() {
      if(this.Carts){
        this.totalCount = this.Carts.reduce(
            (accumulator, currentValue) =>
                parseInt(accumulator, 10) +
                parseInt(currentValue.amount, 10), // 與前一個值相加
            0,
        );
      }

      if(this.CourseCarts){
        this.totalCourseCount = this.CourseCarts.reduce(
            (accumulator, currentValue) =>
                parseInt(accumulator, 10) +
                parseInt(currentValue.amount, 10), // 與前一個值相加
            0,
        );
      }
    },
    cartHref() {
      const windowWidth = document.documentElement.clientWidth;

      if (windowWidth > 768) {
        window.location.href = 'cart';
      }
    },
    openCart() {
      this.showCart = true;
      this.isLoad = true;
    },
    closeCart() {
      this.showCart = false;
      this.isLoad = false;
    },
    async loadOrder() {
      const response = await axios.post('shop/loadOrder');
      const { Order } = response.data;
      const { CourseOrder } = response.data;
      this.Carts = this.filterCart(Order.Carts);
      this.CourseCarts = this.filterCart(CourseOrder.CourseCarts);
      this.calcTotalCount();
    },
    async deleteProductItem(id, key) {
      try {
        this.totalCount -= this.Carts[key].amount;
        this.Carts.splice(key, 1);
        await axios.get(`shop/order/cart/deleteCart?cartId=${id}`);
        global.Message.show('刪除成功');
      } catch (error) {
        global.Message.show('發生錯誤');
        window.location.reload();
      }
    },
    async deleteCourseItem(id, key) {
      try {
        this.totalCourseCount -= this.CourseCarts[key].amount;
        this.CourseCarts.splice(key, 1);
        await axios.get(
          `shop/order/coursecart/deleteCart?cartId=${id}`,
        );
        global.Message.show('刪除成功');
      } catch (error) {
        global.Message.show('發生錯誤');
        window.location.reload();
      }
    },
    handleImageError(event) {
      event.target.src = 'img/pic/no_image_icon.png';
    }
  },
};
</script>
